import { initApiRequest } from "lib/api-request";
import { useQuery } from "react-query";
import { userApi } from "./user.api";

export const useGetPersonalDetails = (id: string, enabled: boolean) => {
  return useQuery({
    queryKey: [userApi.traineePersonalDetail.actionName, id],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: userApi.traineePersonalDetail,
        pathVariables: { traineeId: id }
      });
    },
    select(data) {
      return data?.data.data;
    },
    enabled: enabled
  });
};

export const useGetTraineeActiveTrainee = (enabled: boolean) => {
  return useQuery({
    queryKey: [userApi.getUserActiveTraining.actionName],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: userApi.getUserActiveTraining,
      });
    },
    select(data) {
      return data?.data.data;
    },
    enabled: enabled
  });
};


export const useFetchUserProfile = (id: string, enabled: boolean) => {
  return useQuery({
    queryKey: [userApi.fetchUserProfile.actionName, id],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: userApi.fetchUserProfile,
        pathVariables: { id }
      });
    },
    select(data) {
      return data?.data.data;
    },
    enabled
  });
};
export interface GalleryListParams {
  pageNo?: number;
  pageSize?: number;
}

export const useFetchGalleryByRoutineId = (
  routineId: string | number,
  enabled: boolean,
  params?: any
) => {
  return useQuery({
    queryKey: [userApi.getGalleryByRoutineId.actionName, routineId, params],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: userApi.getGalleryByRoutineId,
        pathVariables: { routineId },
        params: { pageNo: params?.pageNo, pageSize: params?.pageSize }
      });
    },
    select(data) {
      return data?.data.data;
    },
    enabled,
    keepPreviousData: true
  });
};

export const useGetTraineeEthnicitySummary = () => {
  return useQuery({
    queryKey: [userApi.getTraineeEthnicitySummary.actionName],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: userApi.getTraineeEthnicitySummary
      });
    },
    select(data) {
      return data?.data.data;
    }
  });
};

export const useGetTraineeGenderSummary = () => {
  return useQuery({
    queryKey: [userApi.getTraineeGenderSummary.actionName],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: userApi.getTraineeGenderSummary
      });
    },
    select(data) {
      return data?.data.data;
    }
  });
};

export interface TraineeHistoryParams {
  name?: string;
  namc_or_nhpc?: string;
  province_id?: number | string;
  district_id?: number | string;
  dob?: string;
  mobile_number?: string;
  dob_bs?: string;
  email?: string;
  query?: string;
  pageNo?: number;
  pageSize?: number;
}

export interface TrainingListParams {
  query?: string;
  pageNo?: number;
  pageSize?: number;
}

export const useGetTrainingList = (params: any) => {
  return useQuery({
    queryKey: [userApi.getTrainingList.actionName, params],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: userApi.getTrainingList,
        params: params
      });
    },
    select(data) {
      return data?.data.data;
    },
    keepPreviousData: true
  });
};

export const useGetTrainingDetail = (trainingId: number | null) => {
  return useQuery({
    queryKey: [userApi.getTrainingDetail.actionName, trainingId],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: userApi.getTrainingDetail,
        pathVariables: { trainingId: trainingId! }
      });
    },
    select(data) {
      return data?.data.data;
    },
    enabled: trainingId !== null
  });
};

export const useGetTraineeTrainingHistory = (params: TraineeHistoryParams, enabled: boolean) => {
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== '' && v !== undefined && v !== null)
  );
  return useQuery({
    queryKey: [userApi.getTraineeTrainingHistory.actionName, filteredParams],
    queryFn() {
      return initApiRequest<BackendSuccessResponse<any>>({
        apiDetails: userApi.getTraineeTrainingHistory,
        params: filteredParams
      });
    },
    select(data) {
      return data?.data.data;
    },
    enabled
  });
};